import SaveOutlined from "@mui/icons-material/SaveOutlined";
import { Button } from "@mui/material";
import { ReactNode } from "react";

export type SaveButtonProps = {
  loading?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  saveText?: string;
  startIcon?: ReactNode;
  hideStartIcon?: boolean;
  formId?: string;
};

export const SaveButton: React.FC<SaveButtonProps> = ({
  loading: isLoading,
  disabled: isDisabled,
  onClick,
  formId,
  saveText = "Save",
  startIcon = <SaveOutlined />,
  hideStartIcon,
}) => {
  return (
    <Button
      type="submit"
      variant="contained"
      disabled={isDisabled || isLoading}
      startIcon={!hideStartIcon && !isLoading && startIcon}
      onClick={onClick}
      form={formId}
    >
      {isLoading ? "Saving..." : saveText}
    </Button>
  );
};
